import { render, staticRenderFns } from "./RealnameAuthenticationDelog.vue?vue&type=template&id=511a298a&scoped=true"
import script from "./RealnameAuthenticationDelog.vue?vue&type=script&lang=js"
export * from "./RealnameAuthenticationDelog.vue?vue&type=script&lang=js"
import style0 from "./RealnameAuthenticationDelog.vue?vue&type=style&index=0&id=511a298a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511a298a",
  null
  
)

export default component.exports